// Palette
import palette from '../palette';

export default {
  root: {
    textTransform: 'capitalize',
    boxShadow: '',
    '&:hover': {
      boxShadow: ''
    }
  },
  outlined: {},
  contained: {
    boxShadow: '',
    backgroundColor: palette.common.white,
    '&:hover': {
      backgroundColor: palette.common.neutral,
      boxShadow: ''
    }
  }
};
